export enum TIPOCORTE {
  CORTE_IMPREVISTO = 'inesperado',
  CORTE_PROGRAMADO = 'programado',
  PROXIMO_CORTE_PROGRAMADO = 'Próximo corte programado',
  COD_CORTE_PROGRAMADO = 'CP',
  COD_CORTE_IMPREVISTO = 'CI',
}
